import { render, staticRenderFns } from "./ModifyLoginPasswordDialog.vue?vue&type=template&id=3facf1e8"
import script from "./ModifyLoginPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ModifyLoginPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports